<template>
  <div
    class="t"
    :style="{'background-image': `url('https://source.unsplash.com/1600x900/?agriculture')`}"
  >
  
    <form v-if="showLoginForm" novalidate class="md-layout" @submit.prevent="validateUser" style="border-radius: 30px;">
      <CContainer>
        <CRow>
          <CCol>
            <CCardGroup>
              <CCard class="p-4">
                <CCardBody>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <md-card-content>
                    <md-field :class="getValidationClass('email')">
                      <label for="email">Email</label>
                      <md-input
                        type="email"
                        name="email"
                        id="email"
                        autocomplete="email"
                        v-model="form.email"
                        :disabled="sending"
                      />
                      <span class="md-error" v-if="!$v.form.email.required">The email is required</span>
                      <span class="md-error" v-else-if="!$v.form.email.email">Invalid email</span>
                    </md-field>
                  </md-card-content>
                  <md-card-content>
                    <md-field :class="getValidationClass('password')">
                      <label>Password</label>
                      <md-input
                        type="password"
                        name="password"
                        id="password"
                        autocomplete="password"
                        v-model="form.password"
                      />
                      <span
                        class="md-error"
                        v-if="!$v.form.password.required"
                      >The Password is required</span>
                    </md-field>
                  </md-card-content>
                  <span class="text-danger">{{err}}</span>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <md-button type="submit" class="md-success" @click="signin()">Sign in</md-button>
                    </CCol>
                    <CCol col="6" class="text-right">
                        <md-button  @click="showLoginForm = !showLoginForm" class="px-0 ">Create new one</md-button>
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>
              <CCard
                color="white"
                text-color="white"
                class="text-center py-12 d-sm-down-none"
                style=" justify-content: center;"
                body-wrapper
              >
                <img
                  :src="imgLogo"
                  alt
                  width="400"
                  height="400"
                  style=" justify-content: center; margin-top:20px;"
                />
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </form>
    <form v-else novalidate class="md-layout"  style="border-radius: 30px;">
        <CContainer>
          <CRow>
            <CCol>
              <CCardGroup>
                <CCard class="p-4">
                  <CCardBody>
                    <h1>Register</h1>
                    <p class="text-muted">Create your account</p>
                    <md-card-content>
                      <md-field :class="getValidationClassRegister('name')">
                        <label for="name">Full Name</label>
                        <md-input
                          type="text"
                          name="name"
                          id="name"
                          autocomplete="name"
                          v-model="user.name"
                          :disabled="sending"
                          required
                        />
                        <span class="md-error" v-if="!$v.user.name.required">The Full name is required</span>
                        <!-- <span class="md-error" v-else-if="!$v.user.name.maxLength(3)">Invalid Full Name</span> -->
                      </md-field>
                      <md-field :class="getValidationClassRegister('email')">
                        <label for="email">Email</label>
                        <md-input
                          type="email"
                          name="email"
                          id="email"
                          autocomplete="email"
                          v-model="user.email"
                          :disabled="sending"
                          required
                        />
                        <span class="md-error" v-if="!$v.user.email.required">The email is required</span>
                        <span class="md-error" v-else-if="!$v.user.email.email">Invalid email</span>
                      </md-field>
                      <md-field :class="getValidationClassRegister('phone')">
                        <label for="phone">Phone Number</label>
                        <VuePhoneNumberInput
                          id="phone"
                          v-model="user.phone"
                          :preferred-countries="countriesList"
                          :default-country-code="'MA'"
                          @update="onUpdate"
                        ></VuePhoneNumberInput>
                        <span class="md-error" v-if="!$v.user.phone.required">The phone number is required</span>
                      </md-field>
                      <span class="errorphone" v-if="!this.user.phoneCorrect && $v.user.phone.required">Invalid phone number</span>
                      <md-field :class="getValidationClassRegister('password')">
                        <label for="password">Password</label>
                        <md-input
                          type="password"
                          name="password"
                          id="password"
                          autocomplete="new-password"
                          v-model="user.password"
                          required
                        />
                        <span class="md-error" v-if="!$v.user.password.required">The password is required</span>
                      </md-field>
                      <md-field :class="getValidationClassRegister('confirmPassword')">
                        <label for="confirmPassword">Confirm Password</label>
                        <md-input
                          type="password"
                          name="confirmPassword"
                          id="confirmPassword"
                          autocomplete="new-password"
                          v-model="user.confirmPassword"
                          required
                        />
                        <span class="md-error" v-if="!$v.user.confirmPassword.required">Please confirm your password</span>
                        <span class="md-error" v-if="user.password !== user.confirmPassword">Passwords do not match</span>
                      </md-field>
                    </md-card-content>
                    <CRow >
                      <CCol col="6" class="text-left w-1/2">
                        <md-button @click="sendVerificationCode" type="submit" class="md-success">Register</md-button>
                      </CCol>
                      <CCol col="6" class="text-right">
                        <md-button @click="showLoginForm = !showLoginForm" class="mr-12 ">Already have an account?</md-button>
                      </CCol>
                      <CCol>
                        <span class="md-error errSms" v-if="smsEroor == true">{{errregistr}}</span>
                      </CCol>
                      <!-- <CCol>
                        <div class="verification-code-input" v-if="confirmationResult">
                          <label for="verificationCode">Verification Code:</label>
                          <input id="verificationCode" v-model="verificationCode" type="text" placeholder="Enter the code received" />
                        </div>
                        <button class="verify-code-btn" @click="verifyCode" v-if="confirmationResult">Verify Code</button>
                      </CCol> -->
                    </CRow>
                  </CCardBody>
                </CCard>
                <CCard
                  color="white"
                  text-color="white"
                  class="text-center py-12 d-sm-down-none"
                  style="justify-content: center;"
                  body-wrapper
                >
                  <img
                    :src="imgLogo"
                    alt
                    width="400"
                    height="400"
                    style="justify-content: center; margin-top:20px;"
                  />
                </CCard>
              </CCardGroup>
            </CCol>
          </CRow>
        </CContainer>
    </form>
    <div ref="recaptchaContainer" id="recaptcha-container"></div>
    <div></div>
    <!-- <VerificationModal 
      :isVisible="isVerificationModalVisible" 
      :phone="phoneNumber"
      @close="isVerificationModalVisible = false"
    /> -->
    <div v-if="isVerificationModalVisible" class="modal-overlay">
        <div class="modal-content">
          <div class="modal-header-verif">
            <button class="close-button" @click="closeModal">&times;</button>
          </div>
            <div class="verification-container">
                <div ref="recaptchaContainer" id="recaptcha-container"></div>
                <div class="verification-code-input">
                    <label for="verificationCode">Enter the code received : </label>
                        <v-otp-input
                            ref="otpInput"
                            v-model=verificationCode
                            input-classes="otp-input"
                            separator="-"
                            :num-inputs="3"
                            :should-auto-focus="true"
                            input-type="number"
                            placeholder="_"
                            
                        />
                </div>
                <button class="verify-code-btn" @click="verifyCode" >Verify Code</button>
                <span class="md-error errSms" v-if="codeEroor == true">Wrong validation</span>
            </div>

        </div>
    </div>
  </div>
</template>

<script>
import { auth, RecaptchaVerifier, signInWithPhoneNumber } from '@/firebase';
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  maxLength,
  helpers
} from "vuelidate/lib/validators";
import User from "@/services/Users";
import router from "@/routes";
// import VueTelInput from 'vue-tel-input';
// import 'vue-tel-input/dist/vue-tel-input.css';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import firebase from '@/firebase';
import { CCol } from '@coreui/vue';
import VerificationModal from './verification.vue';
// Vue.component('vue-phone-number-input', VuePhoneNumberInput);
export default {
  name: "FormValidation",
  mixins: [validationMixin],
  components: { VuePhoneNumberInput, CCol,VerificationModal },
  props: {
    title: {
      type: String,
      default: "Vue MD"
    },
    sidebarBackgroundImage: {
      type: String,
      default: require("@/assets/img/sidebar-2.jpg")
    },
    imgLogo: {
      type: String,
      default: require("@/assets/img/logo2_agriedge.png")
    },
    sidebarItemColor: {
      type: String,
      default: "green",
      validator: value => {
        let acceptedValues = ["", "purple", "blue", "green", "orange", "red"];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    smsEroor : false,
    codeEroor: false,
    errregistr:'',
    isVerificationModalVisible: false,
    countriesList: ["MA", "PK"],
    num: 1,
    showLoginForm: true,
    form: {
      password: null,
      firstName: null,
      lastName: null,
      gender: null,
      age: null,
      email: null
    },
    user: {
        email: null,
        password: null,
        confirmPassword: null,
        name: null,
        phone: null,
        num:true,
        phoneCorrect:false,
      },
    err: "",
    userSaved: false,
    sending: false,
    lastemail: null,
    verificationCode: '',
    confirmationResult: null,
    displayPhone:true
  }),
  validations: {
    form: {
      firstName: {
        required,
        minLength: minLength(3)
      },
      lastName: {
        required,
        minLength: minLength(3)
      },
      age: {
        required,
        maxLength: maxLength(3)
      },
      gender: {
        required
      },
      email: {
        required,
        email
      },
      password: {
        required
      }
    },
    user: {
        name: {
          required,
          minLength: minLength(4)
        },
        email: {
          required,
          email
        },
        phone: {
            required,
            // phoneCorrect: helpers.withParams(
            //   { type: 'phoneCorrect' },
            //   function(value, parentVm) {
            //     return parentVm.user.phoneCorrect;
            //   }
            // ),
        },
        password: {
          required,
          minLength: minLength(6) // You can define the minimum length for a password
        },
        confirmPassword: {
        required,
        // This is a custom validator to check if the confirmPassword matches the password
        sameAsPassword: function (value) {
            return value === this.user.password;
        }
        }
      }
  },
  methods: {
    onUpdate(payload) {
      this.user.phone = payload.formatInternational;
      this.phoneNumber = payload.formatInternational;
      this.user.phoneCorrect = payload.isValid;
      this.$v.user.phone.$touch();
      console.log(this.user.phoneCorrect);
    },

    getPhoneErrorColor() {
      return this.$v.user.phone.$error ? '#eb4034' : '';
    },

    onPhoneNumberUpdate(value) {
      this.user.phone = value;
    },

    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },

    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },

    getValidationClassRegister(fieldName) {
            const field = this.$v.user[fieldName];
            
            if (field) {
                return {
                "md-invalid": field.$invalid && field.$dirty
                };
            }
    },

    saveUser() {
      this.sending = true;

      // Instead of this timeout, here you can call your API
      window.setTimeout(() => {
        this.lastUser = `${this.form.firstName} ${this.form.lastName}`;
        this.userSaved = true;
        this.sending = false;
        this.clearForm();
      }, 1500);
    },

    validateUser() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.saveUser();
      }
    },

    signin() {
      if (this.form.email.length >= 6 && this.form.password.length > 0) {
        User.login(this.form.email, this.form.password)
          .then(success => {

            this.$store.commit("dkhlat");

            router.push("/");
            
            // window.location.href = "http://localhost:8080/"
          })
          .catch(er => {
            this.err = er;
            console.log(er);
          });
      }
    },

    sendVerificationCode(event) {
      event.preventDefault();
      this.$v.user.$touch();
      if (!this.$v.user.$invalid) {
        User.checkUser(this.phoneNumber,this.user.email).then(res => {
          if(res.data.status == 200)
          {
             if (!window.recaptchaVerifier) {
              console.error("Recaptcha Verifier is not initialized.");
              return;
            }
            const appVerifier = window.recaptchaVerifier;
            signInWithPhoneNumber(auth, this.phoneNumber, appVerifier)
            .then((confirmationResult) => {
              console.log(confirmationResult);
              this.confirmationResult = confirmationResult;
              this.isVerificationModalVisible = true;
            })
            .catch((error) => {
              this.errregistr = 'SMS not send try again, please!'
              this.smsEroor = true;

              console.error("SMS not sent", error);
            })
          }
          else
          {
            this.isVerificationModalVisible = false;
            this.errregistr = 'User aready existed!';
            this.smsEroor = true;
          }
        })
      }
    },

    verifyCode(event) {
      event.preventDefault();
      this.confirmationResult.confirm(this.verificationCode)
        .then((result) => {
          const user = result.user;
          this.registerUser();
          
        }).catch((error) => {
          this.codeEroor = true;
          console.log("Wrong verification code", error);
        });
    },
    closeModal() {
      this.codeEroor = false;
      this.verificationCode = '';
        this.isVerificationModalVisible = false;
        // this.$emit('update:isVisible', false);
    },
    registerUser() {
            User.AddUser(this.user.name,this.user.email,this.phoneNumber,this.user.password) // Assuming the register method exists
            .then((add) => {
              if(add.data.status == 200)
              {
                this.closeModal();
                this.showLoginForm = true;
                this.smsEroor = false;
                this.codeEroor = false;
                this.errregistr = '';
                this.verificationCode = '';
              }
              else
              {
                this.errregistr = add.data.data;
                this.smsEroor = true;
              }
            })
            .catch(error => {
                this.err = error.message;
            });
        // }
    },
  },
  created() {
    if (this.$store.state.Auth === true) router.push("/");
  },
  mounted() {
    let totalCount = 6;
    this.num = Math.ceil(Math.random() * totalCount);
    console.log("Mounting component, initializing RecaptchaVerifier");
    
    // Ensure that the reCAPTCHA container is empty before initializing
    const recaptchaContainer = document.getElementById("recaptcha-container");
    while (recaptchaContainer.firstChild) {
        recaptchaContainer.removeChild(recaptchaContainer.firstChild);
    }
    window.recaptchaVerifier = new RecaptchaVerifier(auth,
        "recaptcha-container",
        {
            size: "invisible",
            callback: (response) => {
                console.log("reCAPTCHA solved");
            },
        },
        auth
    );
    console.log("RecaptchaVerifier initialized:", window.recaptchaVerifier);
  },
  computed : {
    phoneNumberError() {
      if (!this.$v.user.phone.required) {
        return 'The phone number is required';
      } else if (!this.user.phoneCorrect) {
        return 'Invalid phone number';
      }
      return '';
    }
  }
};
</script>

<style lang="scss" scoped>
.errorphone {
  color: red; /* This is an example using CSS variables */
  font-size: 12px;
  line-height: 1.4;
}
.md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}
.test {
  width: 490px;
  height: 360px;
  // display: flex ;
  // justify-content: center;
  // height: 200px;
  // align-items: center;
}
.t {
  width: 100%;
  height: 100%;
  background-position: center;
  background-attachment: fixed;
  background-size: cover;
  background-repeat: no-repeat;
  // background-image: url("../../assets/img/3.jpg");
  // position: absolute;
  display: grid;
  justify-content: center;

  align-items: center;
  align-content: center;
  // box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);
}
.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}
/* Background colour of an input field with value */
.otp-input.is-complete {
  background-color: #e4e4e4;
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input::placeholder {
  font-size: 15px;
  text-align: center;
  font-weight: 600;
}
  .modal-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
  }
  
  .modal-content {
    width: 50%;
    padding: 5px;
    border-radius: 0px;
    justify-content: center;
    align-items: center;
    
    /* Add more styling as per your requirement */
  }
.verification-container {
    max-width: 400px;
    margin: auto;
    padding: 10px;
    // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
  }
  
  .phone-number-input, .verification-code-input {
    margin-bottom: 20px;
  }
  
  input[type="tel"], input[type="text"] {
    width: 100%;
    padding: 10px;
    margin-top: 5px;
    border-radius: 5px;
    border: 1px solid #ccc;
  }
  
  .send-code-btn, .verify-code-btn {
    width: 100%;
    padding: 10px;
    background-color: #31a9e1;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .send-code-btn:hover, .verify-code-btn:hover {
    background-color: #45a049;
  }
  .close-button {
    display: flex;
    justify-content: end;
    font-size: 1.5rem;
    padding: 0px;
    margin: 0px;
  }
  .modal-header-verif {
  display: flex;
  justify-content:end;
  padding-left: 5px;
  padding-right: 5px;
  margin: 0%;
  border-bottom: 1px solid #eaeaea;
  background-color: #31a9e1;
  border-radius: 5px;
  color: #fff;
}
.errSms {
  color: red;
  font-weight: bold;
}
</style>